import { createContext, PropsWithChildren, useContext, useMemo } from 'react';
import { obtenerCartSessionId } from '../storage/cartSessionStorage';

interface CartContextValue {
  sessionId: string;
}

const CartContext = createContext<CartContextValue | null>(null);

export function CartProvider({ children }: PropsWithChildren) {
  const sessionId = useMemo(() => obtenerCartSessionId(), []);
  return <CartContext.Provider value={{ sessionId }}>{children}</CartContext.Provider>;
}

export function useCartContext(): CartContextValue {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error('useCartContext debe usarse dentro de <CartProvider>');
  return ctx;
}
